import { type UserAttributes } from './generated/UserAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { HasExtensionFields } from './concerns/HasExtensionFields';

interface User extends UserAttributes, HasExtensionFields {}

@model
@HasExtensionFields
class User extends ApplicationModel {
  // Start auto-generated
  static typename: 'User' = 'User';
  get typename(): 'User' {
    return 'User';
  }

  static internalTypename: 'User' = 'User';
  get internalTypename(): 'User' {
    return 'User';
  }

  static filterType = 'UserFilters!';
  static filters = { projectId: 'ID', id: '[ID!]', includeAll: 'Boolean' };

  static fields = {
    avatarUrl: attr({ args: { size: 'AvatarSizeEnum' }, readable: true }),
    createdAt: attr({ readable: true }),
    email: attr({ readable: true }),
    id: attr({ readable: true }),
    initials: attr({ readable: true }),
    name: attr({ readable: true }),
    timezone: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    extensionFields: attr.hasMany({
      args: { filters: 'ExtensionFieldFilters' },
      readable: true,
    }),
    projects: attr.hasMany({ readable: true }),
    taskUsers: attr.hasMany({
      args: { filters: 'TaskUserFilters', order: '[TaskUserOrderClause!]' },
      readable: true,
    }),
  };
  // End auto-generated
}

export default User;
